import { observable } from 'mobx';
import { FormikHelpers } from 'formik';

import {
  API_FUNCTION_TYPE,
  API_FUNCTION_TYPE_BANKACCOUNT,
  API_ACCOUNT_BANKACCOUNT,
  API_ACCOUNT_BANKACCOUNT_SAVE,
  API_ACCOUNT_DETAIL_BANKACCOUNT,
  API_ACCOUNT_DETAIL_BANKACCOUNT_SAVE,
  API_ACCOUNT_DETAIL_BANKACCOUNT_PATCH,
  API_ACCOUNT_DETAIL_BANKACCOUNT_PRIMARY,
} from 'api/endpoints';

import { FormStore } from 'stores/formStore';
import { RootStore } from 'stores/rootStore';
import { BankAccount, BankData } from './model';
import { ViewMode } from 'pages/Accounts/Edit/components/viewModes';

export class BankAccountsStore extends FormStore<BankAccount> {
  accountId: string;
  endpointBankAccount: API_FUNCTION_TYPE_BANKACCOUNT;
  endpointSaveBankAccount: API_FUNCTION_TYPE;
  endpointPatchBankAccount: API_FUNCTION_TYPE = API_ACCOUNT_DETAIL_BANKACCOUNT_PATCH;
  @observable bankData?: BankData;

  constructor(rootStore: RootStore, accountId: string, viewMode?: ViewMode) {
    super(rootStore);
    this.accountId = accountId;
    this.bankData = undefined;

    this.endpointBankAccount = viewMode === ViewMode.DETAIL ? API_ACCOUNT_DETAIL_BANKACCOUNT : API_ACCOUNT_BANKACCOUNT;
    this.endpointSaveBankAccount =
      viewMode === ViewMode.DETAIL ? API_ACCOUNT_DETAIL_BANKACCOUNT_SAVE : API_ACCOUNT_BANKACCOUNT_SAVE;
  }

  fetchBankData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<BankData>(this.endpointSaveBankAccount(this.accountId));
    if (response?.data) {
      this.bankData = response.data;
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  fetchBankAccount = async (bankAccountId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(this.endpointBankAccount(this.accountId, bankAccountId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  deleteBankAccount = async (bankAccountId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.delete(this.endpointBankAccount(this.accountId, bankAccountId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  setBankAccountPrimary = async (bankAccountId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.post(API_ACCOUNT_DETAIL_BANKACCOUNT_PRIMARY(this.accountId, bankAccountId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  handleSubmit = async (values: BankAccount, formikHelpers: FormikHelpers<BankAccount>) => {
    return await this.submitData(this.endpointSaveBankAccount(this.accountId), values, {
      formikHelpers,
      reset: false,
      validationPrefixDepth: 0,
      singleValueResponse: true,
    });
  };

  handlePatchSubmit = async (values: BankAccount, formikHelpers: FormikHelpers<BankAccount>) => {
    return await this.rootStore.stores.apiStore.patch(API_ACCOUNT_DETAIL_BANKACCOUNT_PATCH(this.accountId), values);
  };
}
